// typically you will add all of the required polyfills in a separate and
// import that file in index.tsx however Prettier extension keeps messing
// up the positioning of the import so I've no other way for now but to
// include all of the polyfills here instead.
import 'core-js/es6/array';
import 'core-js/es6/date';
import 'core-js/es6/function';
import 'core-js/es6/map';
import 'core-js/es6/math';
import 'core-js/es6/number';
import 'core-js/es6/object';
import 'core-js/es6/parse-float';
import 'core-js/es6/parse-int';
import 'core-js/es6/promise';
import 'core-js/es6/regexp';
import 'core-js/es6/set';
import 'core-js/es6/string';
import 'core-js/es6/symbol';
import 'core-js/es6/weak-map';
import 'core-js/es7/array';
import { entries } from 'core-js/es7/object';
import 'cross-fetch/polyfill';
import * as Cookies from 'js-cookie';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AppInsightsService from './app-insights/service';
import { SeverityLevel } from './app-insights/severity-level';
import {
  ADDRESS_COMPLETE_SCRIPT_URL,
  CONTACT_FORM_EMAIL_RECIPIENTS,
  CRAWLER_REGEX_PATTERNS,
  ERROR_LOG_EMAIL_RECIPIENTS,
  LANGUAGE_CODE_FR_CA,
  MAPS_PLACES_API_URL_EN_CA,
  MAPS_PLACES_API_URL_FR_CA,
  ONGUARD_ERROR_LOG_EMAIL_SENDER,
  RECAPTCHA_LANGUAGE_CODE_EN_CA,
  RECAPTCHA_LANGUAGE_CODE_FR_CA
} from './constants';
import { EmailNameAddress } from './globals';
import { default as i18n } from './locales';
import { MixpanelService } from './mixpanel.service';
// import { unregister } from './registerServiceWorker';
import './scss/index.scss';
import * as SessionStore from './session-store.service';
import * as AppUtils from './utils';

const re = new RegExp(`(${CRAWLER_REGEX_PATTERNS.join('|')})`, 'i');
const isCrawlerOrSiteMonitoringAgent = re.test(navigator.userAgent);

// ****************************************************************************
// Disable React Dev Tools in Production mode
//
if (process.env.REACT_APP_ENV === 'production') {
  (() => {
    // tslint:disable-next-line:no-any
    const DEV_TOOLS = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (typeof DEV_TOOLS === 'object' && DEV_TOOLS !== null) {
      const noop = (): void => undefined;
      for (const [key, value] of entries(DEV_TOOLS)) {
        DEV_TOOLS[key] = typeof value === 'function' ? noop : null;
      }
    }
  })();
}

// unregister service worker
// unregister();

// download Application Insights library scripts
if (!isCrawlerOrSiteMonitoringAgent) {
  AppInsightsService.downloadAndSetup();
}

// ****************************************************************************
// Determine how the navigation to this page was done
//
const navType = window.performance.navigation.type;
let navigationType: string;
switch (navType) {
  case PerformanceNavigation.TYPE_NAVIGATE:
    navigationType = 'TYPE_NAVIGATE';
    break;
  case PerformanceNavigation.TYPE_RELOAD:
    navigationType = 'TYPE_RELOAD';
    break;
  case PerformanceNavigation.TYPE_BACK_FORWARD:
    navigationType = 'TYPE_BACK_FORWARD';
    break;
  default:
    navigationType = 'TYPE_RESERVED';
    break;
}

AppInsightsService.trackTrace({
  message: `Navigation event - ${navigationType}`,
  severityLevel: SeverityLevel.Information
});

// customize Mixpanel based on the current deployment environment
MixpanelService.DebugMode = process.env.REACT_APP_ENV !== 'production';
MixpanelService.DryRun = process.env.REACT_APP_ENV === 'development';
MixpanelService.UninitializedBehavior = process.env.REACT_APP_ENV === 'production' ? 'ignore' : 'ignoreWithWarning';

const ONGUARD_CUSTOMER_SERVICE_EMAIL: EmailNameAddress =
  i18n.language === LANGUAGE_CODE_FR_CA
    ? {
        Name: 'EnGarde',
        Email: 'info@engardeprotection.com'
      }
    : {
        Name: 'OnGuard',
        Email: 'info@onguardprotect.com'
      };

if (process.env.REACT_APP_ENV === 'production') {
  Object.keys(ERROR_LOG_EMAIL_RECIPIENTS).forEach((key) => ERROR_LOG_EMAIL_RECIPIENTS[key].push(ONGUARD_ERROR_LOG_EMAIL_SENDER));
  CONTACT_FORM_EMAIL_RECIPIENTS.push(ONGUARD_CUSTOMER_SERVICE_EMAIL);
}
else if (process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'uat') {
   // CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Kim Stirling', Email: 'kstirling@sigmaloyaltygroup.com' });
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'eric dong', Email: 'edong@sigmaloyaltygroup.com' });
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Anirudh Khetan', Email: 'akhetan@sigmaloyaltygroup.com' });
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Jaydeep Dhimate', Email: 'jdhimate@sigmaloyaltygroup.com' });
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Shubhangi Mahamulkar', Email: 'smahamulkar@sigmaloyaltygroup.com' });
   if (process.env.REACT_APP_ENV === 'uat') {
     CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Kim Stirling', Email: 'kstirling@sigmaloyaltygroup.com' });
   }
   Object.keys(ERROR_LOG_EMAIL_RECIPIENTS).forEach((key) => {
     ERROR_LOG_EMAIL_RECIPIENTS[key].push({ Name: 'eric dong', Email: 'edong@sigmaloyaltygroup.com' });
     ERROR_LOG_EMAIL_RECIPIENTS[key].push({ Name: 'Shubhangi Mahamulkar', Email: 'smahamulkar@sigmaloyaltygroup.com' });
   });
 } else if (process.env.REACT_APP_ENV === 'development') {
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'eric dong', Email: 'edong@sigmaloyaltygroup.com' });
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Nikhil akotkar', Email: 'nakotkar@sigmaloyaltygroup.com' });
   CONTACT_FORM_EMAIL_RECIPIENTS.push({ Name: 'Jaydeep Dhimate', Email: 'jdhimate@sigmaloyaltygroup.com' });
   Object.keys(ERROR_LOG_EMAIL_RECIPIENTS).forEach((key) => {
     ERROR_LOG_EMAIL_RECIPIENTS[key].push({ Name: 'eric dong', Email: 'edong@sigmaloyaltygroup.com' });
   });
 }

function downloadRecaptchaLibraryScript() {
  if (isCrawlerOrSiteMonitoringAgent) {
    return;
  }

  const elRecaptchaScript = document.createElement('script');
  elRecaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${
    i18n.language === LANGUAGE_CODE_FR_CA ? RECAPTCHA_LANGUAGE_CODE_FR_CA : RECAPTCHA_LANGUAGE_CODE_EN_CA
  }`;
  document.body.appendChild(elRecaptchaScript);
}

function downloadAddressCompleteLibraryScript() {
  if (isCrawlerOrSiteMonitoringAgent) {
    return;
  }

  let ADDRESS_COMPLETE_API_URL: string = '';

  if (process.env.REACT_APP_ADDRESS_COMPLETE_API === 'GoogleMaps') {
    ADDRESS_COMPLETE_API_URL = i18n.language === LANGUAGE_CODE_FR_CA ? MAPS_PLACES_API_URL_FR_CA : MAPS_PLACES_API_URL_EN_CA;
  } else if (process.env.REACT_APP_ADDRESS_COMPLETE_API === 'CanadaPost') {
    const { REACT_APP_ADDRESS_COMPLETE_API_KEY: apiKey } = process.env;
    if (typeof apiKey === 'string' && apiKey.length > 0) {
      ADDRESS_COMPLETE_API_URL = ADDRESS_COMPLETE_SCRIPT_URL + process.env.REACT_APP_ADDRESS_COMPLETE_API_KEY;
    }
  }

  if (ADDRESS_COMPLETE_API_URL) {
    const elPlacesApiScript = document.createElement('script');
    elPlacesApiScript.async = true;
    elPlacesApiScript.defer = true;
    elPlacesApiScript.src = ADDRESS_COMPLETE_API_URL;
    document.body.appendChild(elPlacesApiScript);
  }
}

// function downloadLivePersonLibraryScript() {
//   if (isCrawlerOrSiteMonitoringAgent) {
//     return;
//   }

//   const elLivePersonScript = document.createElement('script');
//   const scriptSrc = `/liveperson.${i18n.language.toLowerCase()}.min.js`;
//   elLivePersonScript.async = true;
//   elLivePersonScript.defer = true;
//   elLivePersonScript.src = scriptSrc;
//   document.body.appendChild(elLivePersonScript);
// }

try {
  const clientCode = (Cookies.get(SessionStore.LocalStoreKey.ClientCode) || '').trim().toUpperCase();
  const activationToken =
    clientCode.length > 0 && clientCode === process.env.REACT_APP_CLIENT_CODE
      ? (Cookies.get(SessionStore.LocalStoreKey.Token) || '').trim()
      : '';
  Cookies.remove(SessionStore.LocalStoreKey.Token);
  Cookies.remove(SessionStore.LocalStoreKey.ClientCode);

  // activation token is reset in two cases:
  //   1. the page was accessed by following a link, a bookmark, a form
  //      submission, or a script, or by typing the URL in the address bar?
  //   2. activation token is available in the cookie storage
  const resetActivationToken = !!activationToken || navType === PerformanceNavigation.TYPE_NAVIGATE;
  if (resetActivationToken) {
    AppInsightsService.trackTrace({ message: 'Reset activation token', severityLevel: SeverityLevel.Information });
    SessionStore.setActivationToken(activationToken, true /* removeVerifiedAndActivated */);
  }

  // start the rendering process and once done, do the following:
  //   1. load the reCAPTCHA script with an appropriate language code
  //   2. update the "lang" property of the HTML document to reflect the current language
  const renderStart = AppUtils.getTimestamp();
  AppInsightsService.trackTrace({ message: 'Begin app render', severityLevel: SeverityLevel.Information });
  ReactDOM.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    document.getElementById('root') as HTMLElement,
    () => {
      const duration = AppUtils.getTimestamp() - renderStart;
      AppInsightsService.trackTrace({
        message: 'End app render',
        severityLevel: SeverityLevel.Information,
        properties: { Duration: duration + 'ms' }
      });

      document.documentElement!.setAttribute('lang', i18n.language);

      if (activationToken.length > 0) {
        downloadRecaptchaLibraryScript();
        downloadAddressCompleteLibraryScript();
      }

      // downloadLivePersonLibraryScript();
    }
  );
} catch (error) {
  AppInsightsService.trackException({ exception: error });
  if (process.env.REACT_APP_ENV !== 'production') {
    console.log(`ERROR: __app::init: ${error}`);
  }
}
